export default __webpack_public_path__ + "static/media/mapEntradaMetro.74218e3d.svg";